module.exports = __webpack_public_path__ + "img/logo.60ff54d9.svg";